import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';

export class ProductTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      hover: false
    }
  }

  getProductTileStyle() {
    if (this.props.home) {
      if (this.props.equipment) {
        return css([Styles.listItem, Styles.listItemHome, Styles.listItemEqp])
      } else {
        return css([Styles.listItem, Styles.listItemHome])
      }
    } else {
      return css(Styles.listItem)
    }
  }

  getImage = () => {
    if (this.props.item.image) {
      return this.props.item.image
    }
    if (this.props.item.images &&
      Object.keys(this.props.item.images).length !== 0) {
      return this.props.item.images[Object.keys(this.props.item.images)[0]].image
    }
    return null
  }

  render() {
    const imageUrl = this.getImage()
    return (
      <Card
        className={this.getProductTileStyle()}>
        <CardActionArea>
          <div className={css(Styles.imageContainer)}>
            {/*imageUrl &&
              <CardMedia
                component='img'
                height= {window.innerWidth < 768 ? '200px' : '120px'}
                image={imageUrl}
              />
            */}
            {imageUrl &&
              <img
                src={imageUrl}
                className={css(Styles.pImage)} />
            }
            {!imageUrl &&
              <img
                src={require('../assets/images/fallback-image.jpg')}
                className={css(Styles.pImage)} />
            }
          </div>

          <CardContent
            className={this.props.home ? css(Styles.listTextContainerHome) : css(Styles.listTextContainer)}>
            <div className={css(Styles.listTextSubContainer)}>
              <p className={css(CommonStyles.listItemText)}>
                {this.props.item.subTitle}
              </p>

              <p className={this.props.home ?
                css(CommonStyles.listItemTitle)
                :
                css([CommonStyles.listItemTitle, Styles.listItemTitle])}>
                {this.props.item.title}
              </p>
            </div>

            {this.props.item && this.props.item.rating &&
              <div className={css(Styles.ratingsAndInfoContainer)}>
                <div className={css(Styles.ratingsContainer)}>
                  <Icon className={css(Styles.ratingIcon)}>
                    start
                  </Icon>
                  <p className={css(Styles.ratingText)}>
                    {this.props.item.rating}
                  </p>
                </div>

                {this.props.item && this.props.item.info &&
                  <p className={css(Styles.infoText)}>
                    {this.props.item.info}
                  </p>
                }
              </div>
            }

          </CardContent>
        </CardActionArea>
      </Card>
    )
  }
}

const Styles = StyleSheet.create({
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    minHeight: 180,
    borderRadius: CommonTheme.borderRadius,
    overflow: 'hidden',
    //margin: '10px 10px 10px 0px',
    border: '1px solid transparent',
    boxShadow: '0 2px 20px 0 rgba(0, 0, 30, 0.1), inset 0 -1px 1px 0 rgba(149, 149, 149, 0.5)',
    '@media(max-width: 767px)': {
      //minWidth: '80%',
      //flex: 0.8,
      //margin: '15px 0px',
    },
    ':hover': {
      border: '1px solid #84bf41',
      cursor: 'pointer',
    }
  },
  listItemHome: {
    boxShadow: 'none',
    border: '1px solid #0c4d5d38',//#0C4D5D',
    ':hover': {
      cursor: 'pointer',
      border: '1px solid #8dc73f'
    },
  },
  listItemEqp: {
    border: '1px solid #0c4d5d38'
  },
  listTextContainer: {
    padding: AppTheme.pagePadding * 4,
    minHeight: '80px',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    '@media(min-width: 768px) and (max-width: 1024px)': {
      padding: AppTheme.pagePadding * 2,
    },
  },
  listTextContainerHome: {
    //minHeight: '50px',
    padding: 10,
  },
  ratingsAndInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: AppTheme.pagePadding
  },
  ratingsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryColor,
    borderRadius: 5,
    overflow: 'hidden',
    padding: '3px 5px 3px 5px',
  },
  ratingText: {
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    color: CommonTheme.white,
  },
  ratingIcon: {
    fontSize: 9,
    marginRight: AppTheme.pagePadding / 2,
    color: CommonTheme.white,
  },
  listTextSubContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  infoText: {
    margin: '0px 0px 0px 5px',
    color: CommonTheme.black,
    fontSize: 10,
    wordBreak: 'break-word',
    '@media(max-width: 767px)': {
      fontSize: 12,
      margin: '0px 0px 0px 10px',
    },
  },
  listItemTitle: {
    ':hover': {
      color: CommonTheme.textColor
    },
  },
  imageContainer: {
    //height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 0.5,
    borderBottom: '0.5px solid lightgrey',
    '@media(max-width: 767px)': {
      //height: '200px',
    }
  },
  pImage: {
    maxWidth: '100%',
    maxHeight: '100%'
  }
})


// WEBPACK FOOTER //
// ./src/components/ProductTile.js